import { List, ListItem } from 'seagull';
import RecipientDetails from "../RecipientDetails/RecipientDetails";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MissingSignaturesRecipients = _ref => {
  var _relationship$signato;
  let {
    relationship
  } = _ref;
  const {
    email,
    lastName,
    firstName
  } = relationship.buyer;
  const hasPrimarySignatorySigned = relationship.approvalRecord !== null;
  const recipientDetailsItemStyle = {
    display: 'list-item',
    padding: 0
  };
  return /*#__PURE__*/_jsxs(List, {
    style: {
      listStyleType: 'disc',
      marginLeft: '22px'
    },
    children: [!hasPrimarySignatorySigned && /*#__PURE__*/_jsx(ListItem, {
      style: recipientDetailsItemStyle,
      children: /*#__PURE__*/_jsx(RecipientDetails, {
        testid: "send-proposal-approval-reminder-modal-primary-signatory",
        companyName: relationship.customer.name,
        email: email,
        lastName: lastName,
        firstName: firstName
      })
    }), (_relationship$signato = relationship.signatories) === null || _relationship$signato === void 0 ? void 0 : _relationship$signato.map((signatory, index) => {
      const hasSignatorySigned = signatory.approvalRecord !== null;
      return !hasSignatorySigned && /*#__PURE__*/_jsx(ListItem, {
        style: recipientDetailsItemStyle,
        children: /*#__PURE__*/_jsx(RecipientDetails, {
          testid: "send-proposal-approval-reminder-modal-signatory-".concat(index),
          email: signatory.email,
          lastName: signatory.lastName,
          firstName: signatory.firstName
        }, signatory.id)
      }, signatory.id);
    })]
  });
};
export default MissingSignaturesRecipients;